import { getTokenStore } from "@shared/lib/api/client";
import { localizedPath } from "@shared/lib/localized-path";

import { getPostLoginDestination } from "./postLoginDestination";

/**
 * "Go Home" target on the 404 page: the public landing page for guests, the
 * first enabled feature for a signed-in user (never a disabled page).
 */
export function getNotFoundHomeHref(
  pathname?: string,
  isAuthenticated: boolean = Boolean(getTokenStore().getAccessSync()),
): string {
  if (!isAuthenticated) return localizedPath("/", pathname);
  return localizedPath(getPostLoginDestination(), pathname);
}
